module.exports = __webpack_public_path__ + "static/media/sale-banner.3bbe44c2.jpg";